







































































































import Vue from "vue";
import Emoji from "@/components/Emoji.vue";
import Pagination from "@/components/detail/Pagination.vue";
import CommentInput from "@/components/detail/CommentInput.vue";
import SubComment from "@/components/detail/SubComment.vue";
import Avatar from "@/components/Avatar.vue";
import { formatPublishTime } from "@/utils/filters";
import { replaceEmoji, xssHtml } from "@/utils/util";
import eventEmitter from "@/utils/eventEmitter";
import feedMixin from "@/mixins/feed";
import ssoMixin from "@/mixins/sso";
import commentMixin from "@/mixins/comment";
import constants from "@/utils/constants";
import { ICommentResource, ICommentItem } from "@/types/post";

export default Vue.extend({
  name: "comment-item",
  mixins: [feedMixin, ssoMixin, commentMixin],
  filters: {
    formatPublishTime,
  },
  components: {
    Emoji,
    Pagination,
    CommentInput,
    SubComment,
    Avatar,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: "",
    },
    tid: {
      type: String,
      default: "",
    },
    users: {
      type: Object,
      default: () => ({}),
    },
    praises: {
      type: Object,
      default: () => ({}),
    },
    originUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showReplyInput: false,
      likeClicked: false,
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    isVip() {
      return this.curUser.vipData && this.curUser.vipData.isVip;
    },
    isSelfUser() {
      return this.hasLogin && this.curUser.userId === this.info.uid;
    },
    userInfo() {
      const defaultInfo = {
        nickname: "",
        portrait_url: constants.DEFAULT_AVATAR_URL,
        sig: "",
        user_id: this.info.uid,
        vip_level: "0",
      };
      return this.users[this.info.uid] || defaultInfo;
    },
    userAvatar() {
      if (this.hasLogin && this.curUser.portrait_url) {
        return this.curUser.portrait_url;
      }
      return constants.DEFAULT_AVATAR_URL;
    },
    isLiked() {
      return this.praises[this.info.comment_id] || false;
    },
  },
  mounted() {},
  methods: {
    replaceEmoji,
    xssHtml,
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    handleReply() {
      this.stat("xiaozhan_comment_section_reply_button_click", {
        status: !this.showReplyInput ? "open" : "cancel",
      });

      if (!this.hasLogin) {
        this.popLogin("comment");
        return;
      }

      this.showReplyInput = !this.showReplyInput;
      eventEmitter.emit("start-reply", 0, { comment_id: this.info.comment_id });
    },
    handleReplyClose() {
      this.showReplyInput = false;
    },
    handleReplySuccess() {
      this.showReplyInput = false;
    },
    handleFileDownload(info: ICommentResource, uid: string) {
      if (!info || !info.share_id) {
        return;
      }

      this.stat("xiaozhan_comment_section_upload_download_click", {});

      this.stat("xiaozhan_download_btn_click", {
        from: this.from,
        position: "detail_comment",
        is_collect_all_file: 1,
        is_login: this.hasLogin,
        upUid: uid || "",
      });

      const newInfo = {
        source_id: info.share_id,
        files: info.files,
        user_info: {
          user_id: uid || "",
        },
        id: info.resource_id,
      };

      this.handleDownload(newInfo, this.from, "detail_comment");
    },
    async handleCommentLike(
      info: ICommentItem,
      level: string,
      isLiked: boolean
    ) {
      const result = await this.handleLike(info, level, isLiked);

      if (result === "ok" && !isLiked) {
        this.likeClicked = true;
        setTimeout(() => {
          this.likeClicked = false;
        }, 1000);
      }
    },
  },
});
